import { getEnumObject } from '../utilities.js';

/**
 * Ref: app/Enums/SettlementTypeEnum.php
 */
export const settlementTypes = {
  CORRECTIVE_SETTLEMENT: 4,
  GUARANTEED_SETTLEMENT: 3,
  INSTANT_SETTLEMENT: 2,
  REAL_TIME_SETTLEMENT: 5,
  REGULAR_SETTLEMENT: 1,
};

export default getEnumObject(settlementTypes);
